export default __webpack_public_path__ + "static/kiln-4-8345cfd8f69c23c3091bd663e7b1a422.jpg";